var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 58.3333H11.6665M21.6665 40H6.6665M29.9998 21.6667H13.3332M56.6665 10L34.6784 40.7834C33.7052 42.1459 33.2186 42.8271 33.2396 43.3951C33.258 43.8896 33.4951 44.3504 33.8868 44.6527C34.3368 45 35.174 45 36.8483 45H53.3332L49.9998 70L71.9879 39.2166C72.9612 37.8541 73.4478 37.1729 73.4267 36.6049C73.4084 36.1104 73.1712 35.6496 72.7795 35.3473C72.3296 35 71.4924 35 69.818 35H53.3332L56.6665 10Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFast);
export default __webpack_public_path__ + "static/media/zap-fast.7c732c238e23765470d45c33456ebc45.svg";
export { ForwardRef as ReactComponent };